export const YOUTUBE_LINK = 'https://www.youtube.com/@emperiavr';
export const LINKEDIN_LINK = 'https://www.linkedin.com/company/emperialondon/';
export const DISCORD_LINK = 'https://discord.gg/Zkf7hP9J6U';
export const X_LINK = 'https://x.com/emperiavr';
